window.JRS = window.JRS || {};

(function(JRS) {
  'use strict';

  var _scrollPosition = 0;
  var _isLocked = false;

  /**
   * Lock body scroll. Saves current scroll position and fixes the body.
   * iOS Safari requires the body to be position:fixed to prevent
   * background scrolling when a modal has its own scroll context.
   */
  function lock() {
    if (_isLocked) return;
    _isLocked = true;

    _scrollPosition = window.pageYOffset || document.documentElement.scrollTop || 0;

    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + _scrollPosition + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
  }

  /**
   * Unlock body scroll. Restores original scroll position.
   */
  function unlock() {
    if (!_isLocked) return;
    _isLocked = false;

    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';

    window.scrollTo(0, _scrollPosition);
  }

  /**
   * Check if scroll is currently locked.
   * @returns {boolean}
   */
  function isLocked() {
    return _isLocked;
  }

  JRS.ScrollLock = {
    lock: lock,
    unlock: unlock,
    isLocked: isLocked
  };
})(window.JRS);

